/**
 * isColumnPathTypeId
 *
 * The dot test for the TWO positions in the derive subsystem that may address a
 * composite sub-field: a row projection's declared target column, and a column
 * arm's `sourceCell.typeId`. Accepts everything `isColumnTypeId` accepts, plus
 * `parent.sub` split at the first dot with both halves non-empty — the exact
 * shape `arFormulaTargetFieldSegments` writes, `readArStoredFormulaResult` reads
 * and `readFormDeriveCellValue` reads, so a value this predicate admits always
 * lands on a real, readable path. The four FLAT source positions take
 * `isColumnTypeId` instead, which refuses the dot outright. Consumers:
 * `createFormDeriveEngineConfig` (projection column and `sourceCell` validation)
 * and the drawer's column universe, which must offer exactly what it accepts.
 */

function isColumnPathTypeId(value: unknown): value is string {
  if (typeof value !== 'string' || value === '') return false;
  const dotIndex = value.indexOf('.');
  if (dotIndex === -1) return true;
  return dotIndex > 0 && dotIndex < value.length - 1;
}

export { isColumnPathTypeId };
